import axios from 'axios'
export default axios.create({
  baseURL: 'https://acg.ual.es/things/acg:lab:virtual-routes',
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json'
  }
})